export const INVOICE_STATUS_FILTERS = [
  { value: "all", label: "Toutes" },
  { value: "payee", label: "Payée" },
  { value: "impayee", label: "Impayée" },
  { value: "partielle", label: "Partielle" },
];

const settlement = (invoice) =>
  String(invoice?.FactureRegle || "")
    .trim()
    .toUpperCase();

export function invoiceMatchesStatus(invoice, status) {
  if (!status || status === "all") return true;
  const value = settlement(invoice);
  if (status === "payee") return value === "OUI";
  if (status === "partielle") return value === "PARTIEL";
  if (status === "impayee") return value === "NON";
  return true;
}
